import {DATE_REGEX} from './constants';

const normalizeDate = (dateStr: string = ''): string => {
	const isoMatch = dateStr.match(DATE_REGEX.iso8601);
	if (isoMatch) {
		const [, year, month, day, hour, minute] = isoMatch;
		return `${day}/${month}/${year} ${hour}:${minute}`;
	}

	const brMatch = dateStr.match(DATE_REGEX.brazilian);
	if (brMatch) {
		const [, day, month, year, hour, minute] = brMatch;
		return `${day}/${month}/${year} ${hour}:${minute}`;
	}

	if (DATE_REGEX.timeOnly.test(dateStr)) {
		return dateStr.slice(0, -3);
	}

	return dateStr;
};

export default normalizeDate;
